import React, { useState } from "react";
import { Link } from "react-router-dom"; // Adjust as needed for your routing
import "./realestate.css";
import HeroFooter from "../../components/footer";
import ScrollToTop from "./scrolltop";

const categories = [
  "Contract Management",
  "Foreign Collaborations",
  "Joint Ventures",
  "Corporate Law",
  "Information Technology",
  "Business Ventures",
  "MSME",
  "Start-up India Initiatives",
  "Property and Real Estate"
];

// Map each category to a custom slug
const categoryMapping = {
  "Contract Management": "contract",
  "Foreign Collaborations": "foreign",
  "Joint Ventures": "joint",
  "Corporate Law": "corporate",
  "Information Technology": "information",
  "Business Ventures": "buisness",
  "MSME": "msme",
  "Start-up India Initiatives": "startup",
  "Property and Real Estate": "realestate"
};

const PropertyRealEstate = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <div className="practice-page">
            <ScrollToTop/>
      {/* Mobile Menu Button Visible Only on Mobile */}
      <div className="mobile-menu-button" onClick={toggleSidebar}>
        <i className="fa fa-bars" aria-hidden="true"></i>
      </div>

      {/* Sidebar: Fixed below your existing header */}
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <h2 className="sidebar-title">Our Offerings</h2>
        <ul className="category-list">
          {categories.map((category, index) => (
            <li
              key={index}
              className={category === "Property and Real Estate" ? "active" : ""}
            >
              <Link
                onClick={() => setSidebarOpen(false)}
                 to={`/${categoryMapping[category]}`}
              >
                {category}
              </Link>
            </li>
          ))}
        </ul>
      </aside>

      {/* Main Content */}
      <main className="conten">
        <h2>Property and Real Estate</h2>
        <p className="intro">
          At InduratnaLaw, we provide comprehensive legal services for both residential and commercial properties.
          Whether it’s project formation, property purchase, or alternate dispute resolution, our dedicated team in Pune,
          Maharashtra ensures every transaction is managed with expertise.
        </p>
        <section className="details">
          <h3>Our Expertise</h3>
          <p>
            Navigating the real estate market requires deep industry know-how and robust legal support. Our team assists
            clients from the initial stages of project formation and registration to post-transaction legal documentation.
            We offer expert advice on title verification, drafting of sale deeds, leases, and mortgages.
          </p>
          <p>
            In addition, we facilitate Residential and Commercial Construction Project Formation and Registration
            Services. Our process involves an extensive examination of property ownership to ensure a clear legal title.
          </p>
          <h3>Key Services</h3>
          <ul>
            <li>Property Due Diligence and Search/Title Reports</li>
            <li>MIDC Land Transfer legal documentation </li>
            <li>Property Transfer Agreements</li>
            <li>Housing Society/Commercial Complex Conveyance </li>
            <li>Housing Society/ Commercial Complex Re-development Projects</li>
            <li>Land Development Projects legal management</li>
            <li>Mortgages and Re-conveyance</li>
            <li>Property Litigation Legal Opinion</li>
          </ul>
          <h3>Alternate Dispute Resolution</h3>
          <p>
            Our ADR services include mediation, conciliation, and arbitration for efficient dispute resolution in real estate.
            By resolving conflicts before litigation, we help preserve relationships and reduce time and costs.
          </p>
          <h3>Why Choose InduratnaLaw?</h3>
          <p>
            With extensive local experience and a client-first approach, our team at InduratnaLaw is committed to protecting
            your investments and ensuring smooth property transactions. Trust us to guide you through every legal aspect of real estate.
          </p>
        </section>
      </main>
      <HeroFooter/>
    </div>
  );
};

export default PropertyRealEstate;
